export default __webpack_public_path__ + "static/media/Message_dark.054635ac.svg";